<shared-list-for-loyalty-program-products *ngIf="!slider" class="loyalty-for-member-program-products"
    [loading]="loading$ | async" [programProducts]="programProductItems$ | async" [loyaltyPoints]="loyaltyPoints$ | async">
</shared-list-for-loyalty-program-products>

<shared-list-for-loyalty-program-products-counter *ngIf="slider" [loading]="loading$ | async"
    [programProducts]="programProductItems$ | async" [loyaltyPoints]="loyaltyPoints$ | async"></shared-list-for-loyalty-program-products-counter>